import { FC, useContext, useState } from "react";
import NotificationDispatch, { showErrorNotification } from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useSubsidiaryVatCodesApi } from "../../http/subsidiaryVatCodes/api";
import ModalDialog from "../ui/ModalDialog";

type DeleteSubsidiaryVatCodeDialogProps = {
  subsidiaryVatCodeId: string;
  subsidiaryId: string;
  onClose: () => void;
};

const DeleteSubsidiaryVatCodeDialog: FC<DeleteSubsidiaryVatCodeDialogProps> = ({
  onClose,
  subsidiaryId,
  subsidiaryVatCodeId,
}) => {
  const i18n = useI18n();
  const subVatCodesApi = useSubsidiaryVatCodesApi();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <ModalDialog
      onClose={onClose}
      title={i18n.t.subsidiaryVatCodes.delete}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: onClose,
        },
        {
          title: i18n.t.common.yes,

          onClick: () => {
            setIsSubmitting(true);
            subVatCodesApi
              .deleteAdminSubVatCode(subsidiaryVatCodeId, subsidiaryId)
              .then(onClose)
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {i18n.t.subsidiaryVatCodes.questions.delete}
    </ModalDialog>
  );
};

export default DeleteSubsidiaryVatCodeDialog;
